import * as React from 'react';
import Icons from '../icons';

export default class Errorscreen extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="emptyScreen">
                <Icons name="Errorscreen" className="" /> <br />
                <h2>Connection error</h2>
                <p>Sorry we could not connect to the server.Please try again.</p>
                <a href="javascript:void(0)" className="btn buttonGradient" onClick={this.props.onRefreshClick}>
                <Icons name="Refresh" className="icon mr" /> refresh
                </a> 
            </div>
        );
    }
}